import WalletTokensStatsItem from "./WalletTokensStatsItem";

export default WalletTokensStatsItem;